import en from './import/en';
import de from './import/de';

export default {
  EN: {
    translation: en,
  },
  DE: {
    translation: de,
  },
} as const;
